import { Box, Typography, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';

import { type IVerantosUser } from '@verantos-dev/types-common';

import { ApiWorkflowDialog } from '../../Dialog';

export type AppHeaderAccountDialogProps = {
  user: IVerantosUser;

  onClose: () => void;
};

const RoleList: React.FC<{ roles: { displayName: string }[] }> = ({ roles }) => {
  return (
    <>
      {roles.map((role: { displayName: string }, index: number) => (
        <Typography key={'roles-' + index} variant="body1" fontWeight={500}>
          {role.displayName}
        </Typography>
      ))}
    </>
  );
};

export const AppHeaderAccountDialog = (props: AppHeaderAccountDialogProps) => {
  const { user, onClose } = props;

  const intl = useIntl();
  const theme = useTheme();

  const formatEntry = (labelId: string, value: React.ReactNode, addUnderline = true) => {
    const label = intl.formatMessage({ id: labelId });

    return (
      <Box
        sx={{
          display: 'flex',
          pt: theme.spacing(1),
          pb: theme.spacing(3),
          mb: theme.spacing(2),
          borderBottom: addUnderline ? `1px solid ${theme.palette.divider}` : 'none',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: theme.spacing(4),
            width: '100%',
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Typography variant="body1">{label}</Typography>
          </Box>
          <Box sx={{ flex: 2 }}>
            <Typography variant="body1" fontWeight={500}>
              {value}
            </Typography>
          </Box>
        </Box>
      </Box>
    );
  };

  return (
    <ApiWorkflowDialog
      id="accountInfoDialog"
      title={intl.formatMessage({ id: 'appHeader.accountDialog.title' })}
      onClose={onClose}
      displayButtons={false}
      isValidForSubmit={true}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        {formatEntry(
          'appHeader.accountDialog.label.fullName',
          `${user.firstName} ${user.lastName}`
        )}
        {formatEntry('appHeader.accountDialog.label.email', user.email)}
        {formatEntry('appHeader.accountDialog.label.roles', <RoleList roles={user.roles} />)}
        {formatEntry('appHeader.accountDialog.label.organization', user.organizationName, false)}
      </Box>
    </ApiWorkflowDialog>
  );
};
